import React, { useState, useEffect } from "react";
import { registerLocale } from "react-datepicker";
import DatePicker from "../../../components/DatePickerInput";
import Label from "./LabelF";
import "react-datepicker/dist/react-datepicker.css";
//import "../filtros.scss";
import ar from "date-fns/locale/es";
import { parseISOString, getAtributo } from "../../../context/FuncionesContext";
import Nullifier from "../../../components/Nullifier";

import { TextField } from "@mui/material";
registerLocale("ar", ar);

function transformarFechaISOaMySQL(fechaISO) {
  try {
    if (
      fechaISO === null ||
      fechaISO === undefined ||
      fechaISO === "" ||
      isNaN(Date.parse(fechaISO))
    )
      return null;

    const fecha = new Date(fechaISO);
    const fechaMySQL = fecha.toISOString().replace("T", " ").replace("Z", "");
    return fechaMySQL;
  } catch (er) {
    console.log(er, fechaISO);
    return fechaISO;
  }
}

export const parseFechaFormato = (fechaFormato) => {
  const showTimeSelect =
    fechaFormato.includes("h") ||
    fechaFormato.includes("H") ||
    fechaFormato.includes("m");
  const showTimeSelectOnly =
    !fechaFormato.includes("d") &&
    !fechaFormato.includes("M") &&
    !fechaFormato.includes("y");
  let timeFormat = "";
  let timeIntervals = 60;

  if (fechaFormato.includes("hh") || fechaFormato.includes("HH")) {
    timeFormat += fechaFormato.includes("hh") ? "hh" : "HH";
  }

  if (fechaFormato.includes("mm")) {
    timeFormat += timeFormat ? ":mm" : "mm";
    timeIntervals = 15;
  }

  if (fechaFormato.includes("ss")) {
    timeFormat += timeFormat ? ":ss" : "ss";
  }

  return {
    showTimeSelect,
    showTimeSelectOnly,
    timeFormat,
    dateFormat: fechaFormato,
    timeIntervals,
  };
};

const FechaSimple = (props) => {
  const { id_a, setValor, valor, grid_span, error, setError, cab, data } =
    props;

  const def = data[cab.id_a + "_default"] ?? cab.default;
  const permite_null =
    data[cab.id_a + "_permite_null"] === "s" || cab.permite_null === "s";

  const [fecha, setFecha] = useState("");

  const styles = {
    gridColumn: grid_span,
  };

  function validaFormatoFecha(valor) {
    const regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
    return regex.test(valor);
  }

  useEffect(() => {
    setFecha(parseISOString(valor));
    if (!valor && validaFormatoFecha(def)) {
      setFecha(parseISOString(def));
    }
    if (!valor) return setFecha(null);
  }, []);

  useEffect(() => {
    if (validaFormatoFecha(valor)) {
      setValor(transformarFechaISOaMySQL(valor));
    }
    if (!valor && def && validaFormatoFecha(def)) {
      setValor(def);
    }
  }, []);

  const handleChange = (date) => {
    if (!permite_null && date === null) return;
    setFecha(date);
    setError((e) => {
      return { ...e, [id_a]: false };
    });
    setValor(transformarFechaISOaMySQL(date));
  };

  const fecha_formato = (() => {
    if (props.fecha_formato && props.fecha_formato !== "")
      return props.fecha_formato;
    return cab.fecha_formato ?? "dd/MM/yyyy";
  })();

  const disabled = getAtributo("disabled", data, cab) === "s";
  const {
    showTimeSelect,
    showTimeSelectOnly,
    timeFormat,
    dateFormat,
    timeIntervals,
  } = parseFechaFormato(fecha_formato);

  const placeholder = cab.placeholder ?? cab.fecha_formato ?? "dd/MM/yyyy";
  const ancho = `${placeholder.length + 3}ch`;

  return (
    <div style={styles}>
      <div
        className="filtro_grid_fecha"
        style={{ display: "flex", flexDirection: "column" }}
      >
        <Label
          label={cab.nombre}
          opcionales_null={cab.opcionales_null}
          permite_null={cab.permite_null}
        />

        <div
          style={{ display: "flex", alignItems: "center", gap: "4px" }}
          className="fecha_simple_datepicker"
        >
          <div style={{ width: ancho, flexShrink: 0 }}>
            <DatePicker
              timeFormat={timeFormat}
              timeIntervals={timeIntervals}
              timeCaption="Hora"
              dateFormat={dateFormat}
              locale="ar"
              selected={fecha}
              value={fecha}
              fechaMinima={getAtributo("fecha_minima", data, cab)}
              showYearDropdown={true}
              showTimeSelectOnly={showTimeSelectOnly}
              showTimeSelect={showTimeSelect}
              placeholderText={cab.placeholder ?? cab.fecha_formato}
              onChange={handleChange}
              customInput={
                <TextField
                  fullWidth
                  className={error[id_a] ? "filtro_fecha_input_error" : "w-100"}
                  label={
                    cab.label && cab.label.trim() !== ""
                      ? cab.label
                      : undefined
                  }
                />
              }
              autoComplete="off"
              disabled={disabled}
            />
          </div>

          {permite_null ? (
            <div style={{ flexShrink: 0 }}>
              <Nullifier
                onClick={() => handleChange(null)}
                className="columna_input_date_null"
              />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default FechaSimple;
